import React from "react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { differentElements } from "../../data/content";
export function WhatMakesDifferent() {
  return <section className="bg-paper px-4 py-16 sm:px-6 sm:py-24" data-id="element-328" data-mp="3b7gj9rt1qs1b">
      <div className="mx-auto max-w-4xl" data-id="element-329" data-mp="3b4udnxppumlq">
        <SectionHeading eyebrow="What makes Musculoskeletal Clinical Pathway™ different?" title="Designed Around the Assessment Process, Not Just Isolated Techniques" intro="There are plenty of ways to learn about anatomy, orthopedic tests, and musculoskeletal conditions. The challenge is organizing that knowledge into a coherent assessment process." data-id="element-330" data-mp="3g6tg95dmtfhm" />

        <p className="mt-10 text-center font-display text-xl font-bold text-ink" data-id="element-331" data-mp="2q2f87atixvw">
          I designed this collection around five connected elements:
        </p>

        <ol className="relative mx-auto mt-8 max-w-2xl" data-id="element-332" data-mp="2nh2y8l8vptg8">
          {differentElements.map((el, i) => <li key={el.title} className="relative flex gap-5 pb-8 last:pb-0" data-id="element-333" data-mp="3ccnyqsvya5ma" data-mpi={i}>
              {i < differentElements.length - 1 && <span className="absolute left-[23px] top-12 h-[calc(100%-48px)] w-0.5 bg-brand/25" aria-hidden="true" data-id="element-334" data-mp="37ew77zz7wlim" />}
              <span className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-brand font-display text-xl font-black text-white" data-id="element-335" data-mp="3lbj3s1n9d9o0">
                {i + 1}
              </span>
              <div className="pt-1.5" data-id="element-336" data-mp="3v9grmo17h4g3">
                <h3 className="font-display text-2xl font-extrabold text-ink" data-id="element-337" data-mp="3qdi8beuqicmj">{el.title}</h3>
                <p className="mt-1 text-lg leading-relaxed text-muted" data-id="element-338" data-mp="7z93t5woa807">{el.text}</p>
              </div>
            </li>)}
        </ol>

        <div className="mx-auto mt-12 max-w-2xl space-y-4 text-center text-lg leading-relaxed text-ink/85" data-id="element-339" data-mp="3xxivdoquayc">
          <p data-id="element-340" data-mp="husv1f0akiim">
            The six volumes provide the learning framework, while the five specialized resources give you practical ways to
            review and organize the information.
          </p>
          <p className="text-base italic text-muted" data-id="element-341" data-mp="36npee9ihumqn">
            This is not a substitute for professional training or individualized clinical judgment. It’s an educational
            reference collection designed to complement them.
          </p>
        </div>

        <SectionCta label="Start Assessing With Structure" data-id="element-342" data-mp="3khysr2wydt5w" />
      </div>
    </section>;
}